<flx-resources-grid
  [hasBackground]="false"
  [inputGridOptions]="gridOptions()"
  [tableDef]="workflowsTableCols"
  [uniqueKeys]="['id']"
  [emptyMsg]="'No workflows found'"
  [rowClickEnabled]="true"
  (rowClick)="viewInstanceDetails($event)"
  (gridReady)="onGridReady($event)"
/>

<ng-template
  [flxShowModal]="showDetailsModal()"
  panelClass="flx-instance-workflows-panel"
>
  <flx-workflow-instance-details-modal
    [workflowInstanceId]="selectedWorkflowInstanceId()"
    [workflowName]="selectedWorkflowName()"
    (hideModal)="hideDetailsModal()"
  />
</ng-template>
